import { Injectable, Optional } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthModuleConfig, OAuthResourceServerErrorHandler, OAuthStorage } from 'angular-oauth2-oidc';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AccessInterceptor implements HttpInterceptor {

    private readonly concernedUrls: string[] = ['/api'];

    constructor(private authStorage: OAuthStorage,
                private errorHandler: OAuthResourceServerErrorHandler,
                @Optional() private moduleConfig: OAuthModuleConfig) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.concernedUrls.find(url => req.url.indexOf(url) < 0)) {
            return next.handle(req);
        }
        const headers = req.headers.set('X-AccessRequest', 'CUSTOMER');
        req = req.clone({headers});
        return next.handle(req);
    }
}
